import React from 'react';
import { CheckCircle2, XCircle, HourglassIcon } from 'lucide-react';
import Badge from '../ui/Badge';

function formatTime(dateStr) {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

function ResponseSummary({ members }) {
    const accepted = members.filter((m) => m.accepted === true);
    const rejected = members.filter((m) => m.accepted === false);
    const pending = members.filter((m) => m.accepted === null || m.accepted === undefined);

    return (
        <div>
            <div className="flex flex-wrap gap-2 mb-4">
                <Badge variant="green"><CheckCircle2 className="w-3 h-3" /> Accepted: {accepted.length}</Badge>
                <Badge variant="red"><XCircle className="w-3 h-3" /> Rejected: {rejected.length}</Badge>
                <Badge variant="amber"><HourglassIcon className="w-3 h-3" /> Pending: {pending.length}</Badge>
            </div>

            <div className="overflow-x-auto border border-neutral-200 rounded-xl dark:border-neutral-700">
                <table className="w-full text-left">
                    <thead className="bg-neutral-50 text-neutral-500 text-xs uppercase tracking-wider font-semibold dark:bg-ink-800 dark:text-neutral-500">
                        <tr>
                            <th className="px-6 py-4">Name</th>
                            <th className="px-6 py-4">Role</th>
                            <th className="px-6 py-4">Status</th>
                            <th className="px-6 py-4">Time</th>
                            <th className="px-6 py-4">Remarks</th>
                            <th className="px-6 py-4">Location</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-neutral-100 text-sm dark:divide-neutral-800">
                        {members.length === 0 && (
                            <tr>
                                <td className="px-6 py-8 text-center text-neutral-400 dark:text-neutral-500" colSpan={6}>
                                    No member responses yet.
                                </td>
                            </tr>
                        )}
                        {members.map((m) => {
                            const status = m.accepted === true ? 'Accepted' : m.accepted === false ? 'Rejected' : 'Pending';
                            return (
                                <tr key={m.id} className="hover:bg-neutral-50/80 dark:hover:bg-ink-800/80">
                                    <td className="px-6 py-4 font-medium text-neutral-900 dark:text-neutral-50">{m.member?.fullname || '—'}</td>
                                    <td className="px-6 py-4">{m.member?.role?.role_name || '—'}</td>
                                    <td className="px-6 py-4">
                                        <Badge variant={m.accepted === true ? 'green' : m.accepted === false ? 'red' : 'amber'}>
                                            {status}
                                        </Badge>
                                    </td>
                                    <td className="px-6 py-4">{formatTime(m.response_date)}</td>
                                    <td className="px-6 py-4 max-w-[150px] truncate">{m.remarks || '—'}</td>
                                    <td className="px-6 py-4 text-xs">
                                        {m.lat && m.lng ? `${Number(m.lat).toFixed(4)}, ${Number(m.lng).toFixed(4)}` : '—'}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ResponseSummary;
